import { MOUNTDOOM_2_URL } from './environment-utils'

export const environment = {
  name: 'development',
  production: false,
  SERVICE_WORKER: false,
  SAMMATHNAUR_BASE_URL: 'https://sammathnaur.fieldcontrol.com.br/graphql',
  MORDU_BASE_URL: 'https://mordu.fieldcontrol.com.br/graphql',
  REALTIME_URL: 'https://mouthofsauron-3-rt.fieldcontrol.com.br/corporate/notifications',
  VAPID_PUBLIC_KEY: 'BD7akf-Ek_PIMzyepmqz462dr6T48yMpxywOyC0Xc7Sunn50OsKT6rbg54byp70GJ8kRHahZ-ZaVGj6RgTVlCu8',
  MORANNON_URL: 'https://morannon.fieldcontrol.com.br',
  BLATOUT_APP_ID: '65e5470c-8cf1-44f1-ab1b-1959af90e966',
  SENTRY_DNS: 'https://7200003f449329f033fe72f52b975a39@o142032.ingest.sentry.io/4506745466191872',
  UPLOAD_URL: 'https://ae0ce29usj.execute-api.sa-east-1.amazonaws.com/prod',
  UPLOAD_PRE_SIGNED_POST: 'https://mumakil.fieldcontrol.com.br/s3-pre-signed-post',
  FILE_PREFIX: 'https://s3.amazonaws.com/attachments.fieldcontrol.com.br',
  CIRITH_UNGOL: 'https://app.fieldcontrol.com.br/treinamentos',
  GROUND_BASE_URL: 'https://app.fieldcontrol.com.br/relacionamento-cliente/#',
  MOUNTDOOM_URL: 'http://localhost:4300',
  MOUNTDOOM_2_URL,
  THE_MIRROR_URL: 'https://themirror.fieldcontrol.com.br'
}